/* ScalperIntel — quantity row + machines helper (Phase 2).
   Listens for Dawn's variant-change signal (a `change` event on the hidden
   <input name="id"> inside the product form, fired by VariantSelects/Radios
   after it updates the current variant). Looks up the new variant's
   `machines_per_license` in the data island the snippet embedded, and
   swaps the helper text + visibility with a 150ms opacity fade.

   No-ops when:
     - the data island is missing (snippet not on page)
     - the product form input isn't found yet
     - the new variant has no machines value (helper hides) */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initQtyRow(root) {
    var dataEl = root.querySelector('script[type="application/json"][data-si-machines-data]');
    var helper = root.querySelector('[data-si-machines-helper]');
    var valueEl = root.querySelector('[data-si-machines-value]');
    if (!dataEl || !helper || !valueEl) return;

    var map = {};
    try {
      map = JSON.parse(dataEl.textContent) || {};
    } catch (e) {
      // Malformed JSON — bail. The Liquid-rendered initial state still shows.
      return;
    }

    var sectionId = root.getAttribute('data-section-id');

    // Dawn's product form. There can be more than one (main + installment).
    // We listen on the hidden `name="id"` inputs which VariantSelects updates
    // and dispatches a bubbling `change` event on.
    var formIds = [
      'product-form-' + sectionId,
      'product-form-installment-' + sectionId
    ];

    function update(variantId) {
      var key = String(variantId);
      var machines = Object.prototype.hasOwnProperty.call(map, key) ? map[key] : null;

      // Fade out → swap → fade in.
      helper.classList.add('is-updating');
      window.setTimeout(function () {
        if (machines == null || machines === '') {
          helper.classList.add('si-qty-row__helper--hidden');
          valueEl.textContent = '';
        } else {
          helper.classList.remove('si-qty-row__helper--hidden');
          valueEl.textContent = machines;
        }
        helper.classList.remove('is-updating');
      }, 150);
    }

    function onInputChange(e) {
      var input = e.target;
      if (!input || input.name !== 'id') return;
      var id = parseInt(input.value, 10);
      if (!id) return;
      update(id);
    }

    formIds.forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      // Delegate so we catch the input even if Dawn re-renders the form.
      form.addEventListener('change', onInputChange);
    });
  }

  ready(function () {
    document.querySelectorAll('[data-si-qty-row]').forEach(initQtyRow);
  });
})();
